import {superUsersSlice} from './superUserSlice';

export default superUsersSlice.reducer;
